module.exports = __webpack_public_path__ + "static/img/price.f43c749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price.png
// module id = bt7z
// module chunks = 1